<template>
  <div :class="anchorLinkClasses">
    <a
      :class="linkTitleClasses"
      :href="href"
      :data-scroll-offset="scrollOffset"
      :data-href="href"
      :title="title"
      @click.prevent="goAnchor"
    >{{ title }}</a>
    <slot></slot>
  </div>
</template>
<script>
import * as constants from '../../utils/constants'
const PREFIX_ANCHOR_CLASS = `${constants.PREFIX_CLASS}anchor-link`
export default {
  name: 'TAnchorLink',
  inject: ['anchorCom'],
  props: {
    href: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    scrollOffset: {
      type: Number,
      default() {
        return this.anchorCom.scrollOffset
      }
    }
  },
  data() {
    return {
      prefix: PREFIX_ANCHOR_CLASS
    }
  },
  computed: {
    anchorLinkClasses() {
      return [
        this.prefix,
        this.anchorCom.currentLink === this.href ? `${this.prefix}-active` : ''
      ]
    },
    linkTitleClasses() {
      return [`${this.prefix}-title`]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.anchorCom.init()
    })
  },
  methods: {
    goAnchor() {
      const prevRoute = this.$route
      if (this.anchorCom.animating) return
      const isRoute = this.$router
      if (isRoute) {
        let currentRoute = this.$router.currentRoute
        // 当路由中含有query参数时
        if (currentRoute.query !== {}) {
          let querys = {}
          for (let i in currentRoute.query) {
            querys[i] = currentRoute.query[i]
          }

          this.$router.push({
            path: this.href,
            query: querys
          })
        } else {
          this.$router.push(this.href)
        }
      } else {
        window.location.href = this.href
      }
      const currentRoute = this.$route
      // 如果$route没有变化，点击后也要执行滚动
      if (prevRoute === currentRoute) {
        this.anchorCom.handleHashChange()
        this.anchorCom.handleScrollTo()
      }
      this.anchorCom.$emit('on-select', this.href)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/anchor/anchor-link.vue